module.exports = __webpack_public_path__ + "img/money-dollar-box-fill.abe5c69d.svg";